import React, { useState, useEffect } from "react";
import Box from "@mui/joy/Box";
import Grid from "@mui/joy/Grid";
import Card from "@mui/joy/Card";
import CardOverflow from "@mui/joy/CardOverflow";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import Input from "@mui/joy/Input";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import Textarea from "@mui/joy/Textarea";
import Button from "@mui/joy/Button";
import { Form } from "react-router-dom";
import Autocomplete from "@mui/joy/Autocomplete";
import { getCountries, getCities } from "countries-cities";
import Mapa from "../mapa";
import Calendario from "./subcomponentesaventura/datepicker";
import axios from "axios";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AspectRatio from "@mui/joy/AspectRatio";
import { useNavigate } from "react-router-dom";
import TarjetaDetalleAventura from "../aventuras/tarjetadetalleaventura";
import Alert from "@mui/joy/Alert";
import HikingIcon from "@mui/icons-material/Hiking";
import ErrorIcon from "@mui/icons-material/Error";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";

export default function CrearAventura() {
  let [pasoActual, setpasoActual] = React.useState(0);
  let [pais, setpais] = React.useState(getCountries());
  let [ciudades, setciudad] = React.useState(getCities("Chile"));
  let [categorias, setCategorias] = React.useState();
  let [niveles, setNiveles] = React.useState();
  let [formData, setFormData] = React.useState({
    titulo: "",
    descripcion: "",
    pais: "",
    ciudad: "",
    punto_de_encuentro: "", // Este será actualizado por <Mapa />
    categoria: "",
    coordenadas: "",
    fecha: "",
    nivel: "",
    imagen: "",
  });
  let url = process.env.REACT_APP_FRONTEND_URL;
  let [paisaje, setPaisaje] = React.useState();
  let [estadoBoton, setEstadoBoton] = React.useState({
    avanzar: false,
    retroceder: true,
    mensaje: "Siguiente",
    loading: false,
  });
  let navigate = useNavigate();
  let [notificacion, setNotificacion] = React.useState({
    estado: false,
    contenido: "",
    color: "",
    decoracion: "",
  });

  /* RECOGER NIVEL Y CATEGORIA */
  React.useEffect(() => {
    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */

      let consultaCategorias = async () => {
        let getcategorias = await axios.get(`${url}/api/categorias`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCategorias(getcategorias.data.map((x) => x.nombre_categoria));
        let getniveles = await axios.get(`${url}/api/niveles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setNiveles(getniveles.data.map((x) => x.nombre_nivel));
      };
      consultaCategorias();
    } catch (err) {
      console.log("Tenemos un error al recoger el nively  la categoria");
    }
  }, []);

  /* RECOGER NIVEL Y CATEGORIA */

  /* SET FECHA */

  const handleDateChange = (newDate) => {
    setFormData((prevData) => ({
      ...prevData,
      fecha: newDate ? newDate.format("YYYY-MM-DD") : "", // Formato de fecha deseado
    }));
  };
  /* SET FECHA */

  /* Registrar la Aventura */

  let crearAventura = async () => {
    let datosAventura = new FormData();

    datosAventura.append("titulo", formData.titulo);
    datosAventura.append("descripcion", formData.descripcion);
    datosAventura.append("pais", formData.pais);
    datosAventura.append("ciudad", formData.ciudad);
    datosAventura.append("fecha", formData.fecha);
    datosAventura.append("punto_de_encuentro", formData.punto_de_encuentro);
    datosAventura.append("categoria", formData.categoria);
    datosAventura.append("nivel", formData.nivel);
    datosAventura.append("coordenadas", formData.coordenadas);
    datosAventura.append("imagen", formData.imagen);
    datosAventura.append("latitud", formData.coordenadas.lat);
    datosAventura.append("longitud", formData.coordenadas.lng);

    try {
      /* OBTENER BEARER TOKEN */
      let token = localStorage.getItem("token");

      /* OBTENER BEARER TOKEN */

      let enviarAventura = await axios.post(
        `${url}/api/crear-aventura`,
        datosAventura,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log(enviarAventura.data);
      setNotificacion((valoranterior) => ({
        ...valoranterior,
        estado: true,
        contenido: "¡Aventura publicada! Prepára tu equipo",
        decoracion: <HikingIcon />,
        color: "success",
      }));
      setTimeout(() => {
        navigate("/aventuras");
      }, 3000);
    } catch (err) {
      console.log("error :" + err);
      console.log(err.response.status);
      setNotificacion((valoranterior) => ({
        ...valoranterior,
        estado: true,
        contenido:
          "¡Ups, algo falló. Por favor, revisa la información y vuelve a intentarlo",
        decoracion: <ErrorIcon />,
        color: "danger",
      }));
      setTimeout(() => {
        setNotificacion(() => ({ estado: false }));
      }, 3000);
      setEstadoBoton((valoranterior) => ({ ...valoranterior, loading: false }));
    }
  };

  /* Registrar la Aventura */

  return (
    <Box sx={{ display: "flex", height: "100vh", justifyContent: "center" }}>
      {notificacion.estado && (
        <Alert
          variant="soft"
          className="notificacion"
          startDecorator={notificacion.decoracion}
          color={notificacion.color}
        >
          {notificacion.contenido}
        </Alert>
      )}

      <Grid
        container
        spacing={2}
        sx={{ width: "100%", justifyContent: "center" }}
      >
        <Grid
          item
          xs={12}
          md={4}
          sx={{
            display: "flex",
            flexDirection: "column", // Para organizar los hijos verticalmente
            alignItems: "center", // Centra horizontalmente
            justifyContent: "center", // Centra verticalmente
            height: "100%", // Hace que el Grid ocupe todo el espacio del contenedor
          }}
        >
          <Card
            sx={{ paddingTop: "2rem", paddingBottom: "2rem", width: "80%" }}
          >
            <CardOverflow>
              <Typography level="title-md">Planifica tu Aventura</Typography>
              <Typography level="body-sm" sx={{ marginTop: "0.5rem" }}>
                {" "}
                Completa todos los campos para crear tu próxima aventura. La
                información será usada para mostrar los detalles a otros
                usuarios.
              </Typography>
              <Divider sx={{ marginTop: "0.5rem" }} />
            </CardOverflow>
            <CardContent>
              {pasoActual === 0 && (
                <div>
                  <FormControl>
                    <FormLabel>Título de la Aventura</FormLabel>
                    <Input
                      value={formData.titulo}
                      onChange={(event) => {
                        console.log(formData);
                        setFormData((valoranterior) => ({
                          ...valoranterior,
                          titulo: event.target.value,
                        }));
                      }}
                    />
                  </FormControl>
                  <FormControl sx={{ marginTop: "1rem" }}>
                    <FormLabel>Descripción</FormLabel>
                    <Textarea
                      value={formData.descripcion}
                      minRows={3}
                      onPaste={(event) => event.preventDefault()}
                      onInput={(event) => {
                        setFormData((valoranterior) => ({
                          ...valoranterior,
                          descripcion: event.target.value.slice(0, 300),
                        }));
                      }}
                    />
                    <FormHelperText>
                      Incluye detalles emocionantes sobre la aventura (máximo
                      300 caracteres).
                    </FormHelperText>
                  </FormControl>
                </div>
              )}

              {pasoActual === 1 && (
                <div>
                  <FormControl>
                    <FormLabel>País</FormLabel>
                    <Autocomplete
                      value={formData.pais}
                      options={pais}
                      disableClearable
                      onChange={(event, value) => {
                        setciudad(getCities(value));
                        setFormData((valoranterior) => ({
                          ...valoranterior,
                          pais: value,
                        }));
                      }}
                    />
                  </FormControl>
                  <FormControl sx={{ marginTop: "1rem" }}>
                    <FormLabel>Ciudad</FormLabel>
                    <Autocomplete
                      value={formData.ciudad}
                      options={ciudades}
                      disableClearable
                      onChange={(event, value) => {
                        setFormData((valoranterior) => ({
                          ...valoranterior,
                          ciudad: value,
                        }));
                      }}
                    />
                  </FormControl>
                  <FormControl sx={{ marginTop: "1rem" }}>
                    <FormLabel>Fecha de Salida</FormLabel>
                    <Calendario onDateChange={handleDateChange} />
                    <FormHelperText>
                      Elige el día de inicio de la aventura.
                    </FormHelperText>
                  </FormControl>
                </div>
              )}

              {pasoActual === 2 && (
                <div>
                  <FormControl>
                    <FormLabel>Ubicación de la Aventura</FormLabel>
                    <Mapa
                      onLocationSelect={(data) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          punto_de_encuentro: data.address,
                          coordenadas: data.coordinates,
                        }));
                      }}
                    />
                    <FormHelperText sx={{ marginTop: "1rem" }}>
                      Selecciona el lugar en el mapa donde se realizará la
                      aventura.
                    </FormHelperText>
                  </FormControl>
                </div>
              )}

              {pasoActual === 3 && (
                <div>
                  <FormControl>
                    <FormLabel>Categoría</FormLabel>
                    <Autocomplete
                      value={formData.categoria}
                      options={categorias}
                      disableClearable
                      onChange={(event, value) => {
                        setFormData((valoresanteriores) => ({
                          ...valoresanteriores,
                          categoria: value,
                        }));
                      }}
                    />
                    <FormHelperText>
                      Ejemplo: Senderismo, Camping, etc
                    </FormHelperText>

                    <FormLabel sx={{ marginTop: "1rem" }}>
                      Nivel de Dificultad
                    </FormLabel>
                    <Autocomplete
                      value={formData.nivel}
                      options={niveles}
                      disableClearable
                      onChange={(event, value) => {
                        setFormData((valoresanteriores) => ({
                          ...valoresanteriores,
                          nivel: value,
                        }));
                      }}
                    />
                    <FormHelperText>
                      Indica si es principiante, intermedio o avanzado.
                    </FormHelperText>
                  </FormControl>
                </div>
              )}

              {pasoActual === 4 && (
                <div>
                  <FormControl>
                    <FormLabel>Imagen de la Aventura</FormLabel>
                    <AspectRatio variant="soft" objectFit="cover">
                      <img src={paisaje} alt={formData.titulo} />
                    </AspectRatio>
                    <FormHelperText>
                      Una foto vale más que mil palabras: sube una imagen
                      increíble del lugar.
                    </FormHelperText>

                    <Box
                      sx={{
                        marginTop: "1rem",
                        display: "flex",
                        alignContent: "center",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        component="label"
                        variant="outlined"
                        color="neutral"
                        startDecorator={<CloudUploadIcon />}
                      >
                        Subir Imagen
                        {/* Este input estará oculto pero conectado al botón */}
                        <input
                          type="file"
                          accept="image/jpg,image/png,image/jpeg"
                          hidden
                          onChange={async (event) => {
                            const file = event.target.files[0];
                            if (file) {
                              let opciones = {
                                maxSizeMB: 1, // Máximo 1MB
                                maxWidthOrHeight: 1024, // Redimensionar si es necesario
                                useWebWorker: true,
                              };
                              try {
                                let imagenRecibida = file;

                                /* EN CASO DE ARCHIVOS .HEIC */

                                if (
                                  imagenRecibida.type === "image/heic" ||
                                  imagenRecibida.type === "image/heif"
                                ) {
                                  let blob = await heic2any({
                                    blob: file,
                                    toType: "image/jpeg",
                                    quality: 0.8,
                                  });
                                  imagenRecibida = new File(
                                    [blob],
                                    "imagen_convertida.jpg",
                                    {
                                      type: "image/jpeg",
                                    }
                                  );
                                }

                                /* EN CASO DE ARCHIVOS .HEIC */

                                let imagenComprimida = await imageCompression(
                                  imagenRecibida,
                                  opciones
                                );

                                // Convertir a JPG si el formato es diferente
                                const imagenBlob = await imageCompression(
                                  imagenComprimida,
                                  {
                                    fileType: "image/jpeg",
                                  }
                                );

                                // Crear un nuevo archivo JPG
                                const imagenJPG = new File(
                                  [imagenBlob],
                                  "imagen.jpg",
                                  {
                                    type: "image/jpeg",
                                  }
                                );
                                console.log("Archivo seleccionado:", file);
                                setFormData((valoranterior) => ({
                                  ...valoranterior,
                                  imagen: imagenJPG,
                                }));
                                setPaisaje(URL.createObjectURL(imagenJPG));
                              } catch (err) {
                                console.log(
                                  "Tenemos un error al subir la imagen " + err
                                );
                              }
                            }
                          }}
                        />
                      </Button>
                    </Box>
                  </FormControl>
                </div>
              )}
            </CardContent>
            <CardContent>
              <Grid
                cointainer
                spacing={2}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Grid item>
                  <Button
                    disabled={estadoBoton.retroceder}
                    variant="plain"
                    color="neutral"
                    onClick={() => {
                      setpasoActual(pasoActual - 1);
                      if (pasoActual === 1) {
                        setEstadoBoton((valoranterior) => ({
                          ...valoranterior,
                          retroceder: true,
                        }));
                      }
                      if (pasoActual === 4) {
                        setEstadoBoton((valoranterior) => ({
                          ...valoranterior,
                          mensaje: "Siguiente",
                        }));
                      }
                    }}
                  >
                    Retroceder
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    loading={estadoBoton.loading}
                    disabled={estadoBoton.avanzar}
                    variant="outlined"
                    color="neutral"
                    onClick={() => {
                      if (pasoActual < 4) {
                        setpasoActual(pasoActual + 1);
                      }
                      if (pasoActual === 3) {
                        setEstadoBoton((valoranterior) => ({
                          ...valoranterior,
                          mensaje: "Crear Aventura",
                        }));
                      }
                      if (pasoActual === 4) {
                        console.log("hola");
                        crearAventura();
                        setEstadoBoton((valoranterior) => ({
                          ...valoranterior,
                          loading: true,
                        }));
                      }
                      if (pasoActual === 0) {
                        setEstadoBoton((valoranterior) => ({
                          ...valoranterior,
                          retroceder: false,
                        }));
                      }
                    }}
                  >
                    {estadoBoton.mensaje}
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center", // Alinea el contenido a la izquierda
            justifyContent: "center", // Mantiene el contenido centrado verticalmente
            height: "100%",
            display: { xs: "none", md: "flex" },
          }}
        >
          <TarjetaDetalleAventura
            imagen={paisaje || null}
            latitud={formData.coordenadas.lat}
            longitud={formData.coordenadas.lng}
            pais={formData.pais || "Pais"}
            ciudad={formData.ciudad || "Ciudad"}
            titulo={formData.titulo || "Título de la Aventura"}
            nivel={formData.nivel || "Nivel de Dificultad"}
            categoria={formData.categoria || "Categoría"}
            fecha={formData.fecha + "T00:00:00"}
            descripcion={
              formData.descripcion ||
              "Aquí van los detalles de tu próxima Aventura"
            }
            punto_de_encuentro={
              formData.punto_de_encuentro || "Ubicación de la Aventura"
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}
